import React from "react";
import "./BSUObjectComponent.scss";

import DrawerGoBackComponent from "./DrawerGoBackComponent";
import DrawerRemoveObjectComponent from "./DrawerRemoveObjectComponent";
import { CurrentDrawerOpenType } from "state/slices/RightDrawerSlice";
import BSUPatientHeader from "./BSUPatientHeader";
import { useTypedSelector } from "hooks/store";
import BSUColorItemComponent from "./BSUColorItemComponent";
import CMRSliderComponent, { SliderType } from "./CMRSliderComponent";
import { SelectedBSUBSUType } from "../../../state/slices/SceneSlice";

const BSUObjectComponent = (): JSX.Element => {
    const modelTitle = useTypedSelector((store) => store.ModelWindow.modelTitle);
    const bsuColors = useTypedSelector((store) => store.Scene.bsuAvailableColors);
    const selectedBsu = useTypedSelector((store) => store.Scene.selectedBSU);

    const renderColor = () => {
        if (selectedBsu && selectedBsu.type === SelectedBSUBSUType.IBsu) {
            return (
                <section className="colorPicker">
                    <h2>Change BSU Colour </h2>
                    <article className="colorContainer">
                        {bsuColors.map((bsuColor) => {
                            return (
                                <BSUColorItemComponent
                                    currentColor={bsuColor}
                                    key={bsuColor.name}
                                />
                            );
                        })}
                    </article>
                </section>
            );
        }
    };
    return (
        <section className="bsuComponent">
            <BSUPatientHeader title={modelTitle} />
            <article className="bsuBodyContent">
                {renderColor()}

                <CMRSliderComponent title={"Change BSU Height"} type={SliderType.Bsu} />
                <CMRSliderComponent title={"Rotate"} rotate={"Y"} type={SliderType.Bsu} />
            </article>

            <DrawerRemoveObjectComponent
                classes={"mt-35 onlyDesktop"}
                type={"bsu"}
                payload={"BSU"}
            />
            <DrawerGoBackComponent classes="onlyDesktop" type={CurrentDrawerOpenType.BSUObject} />
        </section>
    );
};

export default BSUObjectComponent;
